import FullScreenIcon from "@/common/images/icons/fullScreenIcon.svg?react";
import ExitFullScreenIcon from "@/common/images/icons/exitFullScreen.svg?react";
import "./FSButton.scss";

interface IFSButtonProps {
  onClick: () => void;
  fullscreen: boolean;
}

export const FSButton: React.FC<IFSButtonProps> = ({
  onClick,
  fullscreen
}) => {
  return (
    <button onClick={onClick} className="FSButton" aria-label={`${fullscreen ? "close" : "open"} fullscreen`}>
      {fullscreen ? <ExitFullScreenIcon /> : <FullScreenIcon />}
    </button>
  );
};
